import React, { useState, useEffect, useRef } from "react";
import BaseLayout from "./BaseLayout";
import BwvSideBar from "../../components/Header/WeddingVendors/BwvSideBar";
import {
  fetchItems,
  fetchSubCategories,
  fetchCategories,
} from "../../components/Header/Data";
import { useDispatch, useSelector } from "react-redux";
import {
  setAllCat,
  setAllItems,
  setAllSubCat,
} from "../../redux/slices/bwvSlice";
import { useLocation } from "react-router-dom";

const BwvSidebarLayout = ({ children, islogin = false }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const [scrollPopupVisible, setScrollPopupVisible] = useState(false);
  const fetchDataCalled = useRef(false);
  const { allCat, allSubCat, allItems } = useSelector((state) => state.bwvData);
  const { searchTerm, selectedCat, selectedSubCat, selectedItem } = useSelector(
    (state) => state.bwvData
  );
  const queryParams = new URLSearchParams(location.search);
  const selected = queryParams.get("selected") || "";
  const fetchData = async () => {
    try {
      const params = {
        ...(selected === "entertainment" ? { entertainment: 1 } : {}),
      };
      const categoriesData = await fetchCategories(params);
      dispatch(setAllCat(categoriesData || []));
      if (selected === "entertainment") {
        dispatch(setAllSubCat([]));
        dispatch(setAllItems([]));
        return;
      }
      const subCategoriesData = await fetchSubCategories(params);
      const itemsData = await fetchItems(params);
      dispatch(setAllSubCat(subCategoriesData || []));
      dispatch(setAllItems(itemsData || []));
    } catch (error) {
      console.error("Error fetching BWV data:", error);
      // Set empty arrays on error to prevent undefined access
      dispatch(setAllCat([]));
      dispatch(setAllSubCat([]));
      dispatch(setAllItems([]));
    }
  };

  useEffect(() => {
    // Fetch data regardless of login status for wedding vendors
    if (!fetchDataCalled.current || selected) {
      fetchData();
      fetchDataCalled.current = true;
    }
  }, [selected]);

  const sidebarProps = {
    categories: allCat || [],
    subCategories: allSubCat || [],
    items: allItems || [],
    setScrollPopupVisible,
  };

  const enhancedChildren = React.Children.map(children, (child) =>
    React.isValidElement(child)
      ? React.cloneElement(child, {
          categories: allCat || [],
          subCategories: allSubCat || [],
          items: allItems || [],
          scrollPopupVisible,
          setScrollPopupVisible,
        })
      : child
  );

  return (
    <BaseLayout
      SidebarComponent={BwvSideBar}
      sidebarProps={sidebarProps}
      islogin={islogin}
    >
      {enhancedChildren}
    </BaseLayout>
  );
};

export default BwvSidebarLayout;
